import cn from 'classnames';
import { t } from 'i18next';
import React, { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import './styles.scss';

interface Props {
	balance?: number;
	className?: string;
}

const BalanceCount: React.FC<Props> = ({ balance, className }) => {
	const [showAnimation, setShowAnimation] = useState(true);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const container = containerRef.current;

		if (container) {
			container.classList.add('BalanceCount__animateWidth');
			container.addEventListener('animationend', () => {
				container.classList.remove('BalanceCount__animateWidth');
				setShowAnimation(true);
			});
		}
		return () => {
			if (container) {
				container.removeEventListener('animationend', () => {});
			}
		};
	}, []);

	return (
		<div
			ref={containerRef}
			className={cn('BalanceCount__amount', { BalanceCount__animateLargerWidth: balance && balance.toFixed(2).length > 7 }, className)}
		>
			{showAnimation ? (
				<div>
					<CountUp
						suffix={`&nbsp;${t('currency')}`}
						end={balance || 0}
						duration={1.2}
						decimals={2}
						decimal={t('decimal')}
						separator={' '}
						delay={0.05}
						redraw={false}
						onEnd={() => setShowAnimation(false)}
					/>
				</div>
			) : (
				t('Common_currency', { val: balance || 0 })
			)}
		</div>
	);
};

export default BalanceCount;
